import { Component } from '@angular/core';

@Component({
  selector: 'app-p-embed',
  templateUrl: './p-embed.component.html',
  styleUrls: ['./p-embed.component.scss']
})
export class PEmbedComponent {

}
